export const Functions = {
  create: false,
  delete: false,
  detail: true,
  search: true,
};

export const PageName = '龙舟列表';
